import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactCountryFlag } from "react-country-flag";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import { useRouter } from "next/router";
import { Loading, useTranslation } from ".";
const localeMap = {
    fi: { name: "fi", flag: "FI" },
    en: { name: "en", flag: "GB" },
    se: { name: "sv", flag: "SE" },
};
export const LocaleMenu = ({ menuTitle, onClickHandler, dataCyDropdown, dataCyMenuItem, loading, includedLocales = [], }) => {
    const { t } = useTranslation("error");
    const { locales } = useRouter();
    const menu = locales
        ?.map((locale) => {
        const { name, flag } = localeMap[locale];
        if (includedLocales.includes(name)) {
            return (_jsx(Menu.Item, { "data-cy": `${dataCyMenuItem}-${name}`, disabled: loading, icon: _jsx(ReactCountryFlag, { "aria-label": `${name} flag`, countryCode: flag, style: {
                        fontSize: "2rem",
                        lineHeight: "2rem",
                        marginRight: "12px",
                    } }, name), children: t(`common:lang.${name}`) }, locale));
        }
    })
        .filter(Boolean);
    return (_jsx(Dropdown, { disabled: loading || includedLocales.length === 0, overlay: _jsx(Menu, { onClick: onClickHandler, children: menu }), placement: "bottomLeft", trigger: ["click"], arrow: true, children: _jsxs("span", { "data-cy": dataCyDropdown, style: { whiteSpace: "nowrap" }, children: [_jsx("span", { style: { marginLeft: 8, marginRight: 8 }, children: menuTitle }), loading ? _jsx(Loading, { size: "small" }) : _jsx(DownOutlined, {})] }) }));
};
//# sourceMappingURL=LocaleMenu.js.map